import { combineReducers } from "redux";
import otpReducer from "./otpReducer";
import userInformationReducer from "./userInformationReducer";

const allReducers = combineReducers({
	otpReducer,
	userInformationReducer,
});
const rootReducer = (state, action) => {
	if (action.type === "RESET_APP") {
		state = undefined;
	}

	return allReducers(state, action);
};
export default rootReducer;
